import dynamic from 'next/dynamic'
import { ContainerBlock } from './Container/Component'
import { GridBlock } from './Grid/Component'
import { GridCellBlock } from './GridCell/Component'
import type { Block } from 'payload'
import { BannerBlock } from '@/blocks/Banner/Component'
import { ButtonBlock } from '@/blocks/Button/Component'
import { DivBlock } from '@/blocks/Div/Component'
import { ProfilePictureBlock } from '@/blocks/ProfilePicture/Component'
import { UICardBlock } from '@/blocks/UICard/Component'
import { HeaderBlock } from '@/blocks/Header/Component'
import { ProgressBarBlock } from '@/blocks/ProgressBar/Component'
import { ContentBlock } from '@/blocks/Content/Component'
import { CallToActionBlock } from '@/blocks/CallToAction/Component'
import { MediaBlock } from '@/blocks/Media/Component'
import { RoundedGraphicBlock } from '@/blocks/RoundedGraphic/Component'
import { CoachCTABlock } from '@/blocks/CoachCTA/Component'
import { SpacerBlock } from '@/blocks/Spacer/Component'
import { CallToActionStripBlock } from '@/blocks/StripCTA/Component'
import { SectionBlock } from '@/blocks/Section/Component'
import { HtmlBlock } from '@/blocks/HTML/Component'
import { BoxBlock } from '@/blocks/Box/Component'
import { RichTextBlock } from '@/blocks/RichText/Component'
import { DetailCardBlock } from '@/blocks/DetailCard/Component'
import { PillBlock } from '@/blocks/Pill/Component'
import { LogoBlock } from '@/blocks/Logo/Component'
import { PageHeaderBlock } from '@/blocks/PageHeader/Component'
import { PaymentBadgesBlock } from '@/blocks/PaymentBadges/Component'
import { DetailsBlock } from '@/blocks/Details/Component'
import { EmptyStateBlock } from '@/blocks/EmptyState/Component'
import { HeroSectionBlock } from '@/blocks/HeroSection/Component'
import { RichTextSectionBlock } from '@/blocks/RichTextSection/Component'
import { ListPageLayoutBlock } from '@/blocks/ListPageLayout/Component'
import { DetailPageLayoutBlock } from '@/blocks/DetailPageLayout/Component'
import { SidebarLayoutBlock } from '@/blocks/SidebarLayout/Component'
import { CardBlock } from '@/blocks/Card/Component'
import { SidebarCardBlock } from '@/blocks/SidebarCard/Component'
import { BreadcrumbsBlock } from '@/blocks/Breadcrumbs/Component'
import { ExpandableTextBlock } from '@/blocks/ExpandableText/Component'
import { CollapsibleBlock } from '@/blocks/Collapsible/Component'
import { StackBlock } from '@/blocks/Stack/Component'
import { RowBlock } from '@/blocks/Row/Component'
import { ColumnsBlock } from '@/blocks/Columns/Component'
import { ColumnBlock } from '@/blocks/Column/Component'
import { DividerBlock } from '@/blocks/Divider/Component'
import { ColorBandBlock } from '@/blocks/ColorBand/Component'

// Interactive, heavier blocks are code-split: still rendered on the server, but their JavaScript
// (maps, forms with Radix Select, galleries, Lottie, …) is only sent to pages that contain them.
// Imported statically, every CMS page shipped all of it. Layout shells stay static: they are
// small and on nearly every page.
const AuthBlock = dynamic(() => import('@/blocks/Auth/Component').then((m) => m.AuthBlock))
const DonationOptionsBlock = dynamic(() => import('@/blocks/DonationOptions/Component').then((m) => m.DonationOptionsBlock))
const FormBlock = dynamic(() => import('@/blocks/Form/Component').then((m) => m.FormBlock))
const BuyTicketsBlock = dynamic(() => import('@/blocks/BuyTickets/Component').then((m) => m.BuyTicketsBlock))
const CoachListBlock = dynamic(() => import('@/blocks/CoachList/Component').then((m) => m.CoachListBlock))
const CoachMapBlock = dynamic(() => import('@/blocks/CoachMap/Component').then((m) => m.CoachMapBlock))
const LottieBlock = dynamic(() => import('@/blocks/Lottie/Component').then((m) => m.LottieBlock))
const PhotoGalleryBlock = dynamic(() => import('@/blocks/PhotoGallery/Component').then((m) => m.PhotoGalleryBlock))
const NewsTickerBlock = dynamic(() => import('@/blocks/NewsTicker/Component').then((m) => m.NewsTickerBlock))
const PartnersShowcaseBlock = dynamic(() => import('@/blocks/PartnersShowcase/Component').then((m) => m.PartnersShowcaseBlock))
const CookieConsentBlock = dynamic(() => import('@/blocks/CookieConsent/Component').then((m) => m.CookieConsentBlock))
const DonatePopupBlock = dynamic(() => import('@/blocks/DonatePopup/Component').then((m) => m.DonatePopupBlock))
const YouTubeBlock = dynamic(() => import('@/blocks/YouTube/Component').then((m) => m.YouTubeBlock))
const CodeBlock = dynamic(() => import('@/blocks/Code/Component').then((m) => m.CodeBlock))

export const blockComponents = {
  authBlock: AuthBlock,
  banner: BannerBlock,
  content: ContentBlock,
  cta: CallToActionBlock,
  code: CodeBlock,
  donationOptions: DonationOptionsBlock,
  profilePicture: ProfilePictureBlock,
  formBlock: FormBlock,
  mediaBlock: MediaBlock,
  roundedGraphic: RoundedGraphicBlock,
  coachCta: CoachCTABlock,
  spacer: SpacerBlock,
  ctaStrip: CallToActionStripBlock,
  section: SectionBlock,
  html: HtmlBlock,
  box: BoxBlock,
  richText: RichTextBlock,
  container: ContainerBlock,
  buyTickets: BuyTicketsBlock,
  grid: GridBlock,
  gridCell: GridCellBlock,
  details: DetailsBlock,
  coachList: CoachListBlock,
  coachMap: CoachMapBlock,
  lottie: LottieBlock,
  photoGalleryBlock: PhotoGalleryBlock,
  newsTicker: NewsTickerBlock,
  partnersShowcase: PartnersShowcaseBlock,
  button: ButtonBlock,
  uicard: UICardBlock,
  headerblock: HeaderBlock,
  progressbar: ProgressBarBlock,
  detailCard: DetailCardBlock,
  pill: PillBlock,
  logo: LogoBlock,
  pageHeader: PageHeaderBlock,
  paymentBadges: PaymentBadgesBlock,
  cookieConsent: CookieConsentBlock,
  donatePopup: DonatePopupBlock,
  div: DivBlock,
  youtube: YouTubeBlock,
  emptyState: EmptyStateBlock,
  heroSection: HeroSectionBlock,
  richTextSection: RichTextSectionBlock,
  listPageLayout: ListPageLayoutBlock,
  detailPageLayout: DetailPageLayoutBlock,
  sidebarLayout: SidebarLayoutBlock,
  card: CardBlock,
  sidebarCard: SidebarCardBlock,
  breadcrumbs: BreadcrumbsBlock,
  expandableText: ExpandableTextBlock,
  collapsible: CollapsibleBlock,
  stack: StackBlock,
  rowBlock: RowBlock,
  columns: ColumnsBlock,
  column: ColumnBlock,
  divider: DividerBlock,
  colorBand: ColorBandBlock,
}

